import { searchEntities } from '../../store/selectors/search';

export const selectCounts = state => searchEntities(state, 'counts', {});
